export function ShowMenuMovil() {
    const navicon = document.getElementById('Navicon');
    if (navicon.className == 'close') {
        navicon.classList.remove('close');
        document.getElementById('HMenus').classList.remove('header__menu--open');
    } else {
        navicon.classList.add('close');
        document.getElementById('HMenus').classList.add('header__menu--open');
    }
}

export function GoToInPage(idSection) {
    document.getElementById(idSection).scrollIntoView({ behavior: 'smooth' });
    ShowMenuMovil();
}
